import { SearchOutlined } from '@ant-design/icons';
import { DynamicBlock } from "@components/block";
import { SingleHeader } from "@components/header";
import { useWindowSize } from '@components/window-size-provider';
import { Routes } from "@lib/constants";
import { sanitizeSearchInput, stripTags } from "@lib/utils";
import { getWordpressVars } from "@lib/wordpressVars";
import { useGetPagesQuery } from "@services/Page";
import { Col, Input, Layout, Row, Spin } from "antd";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import { useGetHeaderAdsQuery } from "@mwServices/Ads";
import { HeaderAd } from "@components/header-ad";

const { Search } = Input;

const CollectorContentPage = () => {
  const { isLargeScreen } = useWindowSize();
  const ID = getWordpressVars().ID;
  const [Data, setData] = useState({
    ID: null,
    title: null,
    slug: null,
    date: null,
    description: null,
    blocks: [],
    ads: [],
    author: null,
    type: null,
    image: {
      focalPoint: {
        top: 50,
        left: 50,
      },
      src: ''
    },
    taxonomy: null,
  });

  const {
    isFetching,
    isLoading,
    data,
  } = useGetPagesQuery({
    id: ID, parts: [
      'title', 'image', 'link',
      'blocks', 'ads', 'user'
    ]
  });

  const headerAdsQuery = useGetHeaderAdsQuery({ID});
  const [desktopHeaderAd, setDesktopHeaderAd] = useState<any>();
  const [mobileHeaderAd, setMobileHeaderAd] = useState<any>();
  useEffect(() => {
      if (headerAdsQuery.data) {
          headerAdsQuery.data.forEach((ad) => {
              if (ad.isMobile) {
                  setMobileHeaderAd(ad);
              } else {
                  setDesktopHeaderAd(ad);
              }
          });
      }
  }, [headerAdsQuery.data]);

  const onSearch = (value: string) => {
    window.location.href = `${Routes.COLLECTOR_CONTENT_SEARCH}/?search=${sanitizeSearchInput(value)}`;
  };

  useEffect(() => {
    if (data) {
      setData(data.results);
    }
  }, [data]);

  return (
    <Layout className="page collectors-resources">
      <Head>
        <title>{stripTags(Data.title)}</title>
      </Head>
      <Row>
        <Col span={24}>
          <Spin size="large" spinning={isFetching || isLoading}>
            <SingleHeader
              className={`hero-header`}
              title={`${Data.title || ''}`}
              imgSrc={Data.image.src}
              focalPoint={Data.image.focalPoint}
              justify="center"
              parallax={false}
            />
          </Spin>
        </Col>
      </Row>
      <Row justify={`center`}>
        <Col className="search-input-wrapper" xs={23} lg={22}>
          <Search
            prefix={<SearchOutlined />}
            onSearch={onSearch}
            className="search-input"
            placeholder="Search"
            enterButton="GO"
            size="large"
            allowClear
          />
        </Col>
      </Row>
      <Row justify={`center`}>
        <Col xs={23} lg={22}>
          <Row
            className={isLargeScreen ? 'grid-auto-350' : ''}
            gutter={[30, 30]}
          >
            <Col className={`border-r-1-light-grey`}>
              {(isLargeScreen && desktopHeaderAd) &&
                <HeaderAd
                  campaignUrl={desktopHeaderAd.campaignUrl}
                  adId={desktopHeaderAd.adId}
                  imageUrl={desktopHeaderAd.imageUrl}
                  style={{marginBottom: '40px'}}
                />
              }
              {(!isLargeScreen && mobileHeaderAd) &&
                <HeaderAd
                  campaignUrl={mobileHeaderAd.campaignUrl}
                  adId={mobileHeaderAd.adId}
                  imageUrl={mobileHeaderAd.imageUrl}
                  style={{marginBottom: '16px'}}
                />
              }
              <Spin size="large" spinning={isFetching || isLoading}>
                {Data?.blocks
                  && <DynamicBlock blocks={Data?.blocks} />
                }
              </Spin>
            </Col>
            <Col>
              <Spin size="large" spinning={isFetching || isLoading}>
                {Data?.ads && <DynamicBlock blocks={Data?.ads} />}
              </Spin>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout >
  );
};

export default CollectorContentPage;


